import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";

type Product = {
  name: string;
  brandName: string;
  description: string;
  images: string[];
  categories: string[];
  unitStockMeasurement: string;
  unitWeight: string;
  unitPrice: string;
  bulkStockMeasurement: string;
  bulkWeight: string;
  bulkPrice: string;
  bulkShippingMinQtyBetty: string;
  bulkShippingMinQtyUber: string;
  bulkShippingMinQtyWalkIn: string;
  bulkShippingMaxQtyBetty: string;
  bulkShippingMaxQtyUber: string;
  bulkShippingMaxQtyWalkIn: string;
  lowBulkStock?: string;
  lowUnitStock?: string;
};

export const useAddProductMutation = () => {
  const token = localStorage.getItem("BETTY_ADMIN_USER_TOKEN");

  return useMutation({
    mutationFn: async (payload: Product) => {
      const updatedPayload = {
        ...payload,
        unitPrice: +payload.unitPrice,
        bulkPrice: +payload.bulkPrice,
        bulkShippingMinQtyBetty: +payload.bulkShippingMinQtyBetty,
        bulkShippingMinQtyUber: +payload.bulkShippingMinQtyUber,
        bulkShippingMinQtyWalkIn: +payload.bulkShippingMinQtyWalkIn,
        bulkShippingMaxQtyBetty: +payload.bulkShippingMaxQtyBetty,
        bulkShippingMaxQtyUber: +payload.bulkShippingMaxQtyUber,
        bulkShippingMaxQtyWalkIn: +payload.bulkShippingMaxQtyWalkIn,
        lowBulkStock: payload.lowBulkStock ? +payload.lowBulkStock : undefined,
        lowUnitStock: payload.lowUnitStock ? +payload.lowUnitStock : undefined,
        images: payload.images,
      };

      const response = await axiosInstance.post("/products", updatedPayload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    },
    onSuccess: (data: any) => {
      message.success(data?.message || "Product added successfully");
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message || "Error adding product");
    },
  });
};
